import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';

@Injectable({ providedIn: 'root' })
export class ProjectModuleService {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;

  public create(dataRecord: any, tableName: string) {
    let url = `${this.BASE_URL}${tableName}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post(url, dataRecord, { headers: headers })
      .toPromise()
      .then(response => response);
  }

  public get(_fv: number, tableName): Promise<any> {
    const foreignKey: string = 'ProjectId';
    const filterQ = `%24filter=${foreignKey}%20eq%20${_fv}`;
    let url = `${this.BASE_URL}${tableName}?${filterQ}&%24count=true`;

    return this.http
      .get(url)
      .toPromise()
      .then(response => response);
  }

  public update(_fv: number, projectModule: any, tableName) {
    let url = `${this.BASE_URL}${tableName}(${_fv})`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .patch(url, projectModule, { headers: headers })
      .toPromise()
      .then(response => response);
  }
}